/* Botón de contacto que se abre en tarjeta - Salas García Ópticos
   Sustituye el enlace de WhatsApp de la ficha ("¿Tienes dudas?") por un botón
   que se estira hasta mostrar WhatsApp, teléfonos, dirección y horario. */
(function () {
  'use strict';

  /* Datos de la tarjeta: se cambian aquí */
  var INFO = {
    label: '¿Tienes dudas? Hablemos',
    title: 'Hablemos',
    whatsappLabel: 'Escribir por WhatsApp',
    phones: [
      ['Teléfono', '950 135 081', '950135081'],
      ['Móvil', '638 010 656', '638010656']
    ],
    address: 'Avenida Guillermo Reyna, 24, Local 56, Huércal-Overa',
    hours: [
      ['Lunes a viernes', '9:30 a 13:30 y de 16:00 a 20:00'],
      ['Sábados', '10:00 a 13:30']
    ]
  };
  var MAX_WIDTH = 420;
  var CLOSED_HEIGHT = 52;
  var counter = 0;

  function make(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  function build(link) {
    var host = link.closest('.product__text') || link.parentElement;
    if (!host || host.getAttribute('data-sg-morph')) return;
    host.setAttribute('data-sg-morph', '1');

    var id = 'sg-m-' + (++counter);
    var wrap = make('div', 'sg-morph');
    var open = make('button', 'sg-m-open', INFO.label);
    open.type = 'button';
    open.setAttribute('aria-expanded', 'false');
    open.setAttribute('aria-controls', id);

    var card = make('div', 'sg-m-card');
    card.id = id;
    card.setAttribute('aria-hidden', 'true');
    if ('inert' in card) card.inert = true;

    card.appendChild(make('p', 'sg-m-title', INFO.title));

    var wa = make('a', 'sg-m-wa', INFO.whatsappLabel);
    wa.href = link.href;
    wa.target = '_blank';
    wa.rel = 'noopener';
    card.appendChild(wa);

    var dl = make('dl', 'sg-m-info');
    INFO.phones.forEach(function (p) {
      dl.appendChild(make('dt', '', p[0]));
      var dd = make('dd');
      var a = make('a', '', p[1]);
      a.href = 'tel:' + p[2];
      dd.appendChild(a);
      dl.appendChild(dd);
    });
    dl.appendChild(make('dt', '', 'Dirección'));
    dl.appendChild(make('dd', '', INFO.address));
    dl.appendChild(make('dt', '', 'Horario'));
    var hours = make('dd');
    INFO.hours.forEach(function (h, i) {
      if (i) hours.appendChild(document.createElement('br'));
      hours.appendChild(document.createTextNode(h[0] + ': ' + h[1]));
    });
    dl.appendChild(hours);
    card.appendChild(dl);

    var close = make('button', 'sg-m-close', 'Cerrar');
    close.type = 'button';
    card.appendChild(close);

    wrap.appendChild(open);
    wrap.appendChild(card);

    host.textContent = '';
    host.appendChild(wrap);

    var isOpen = false;

    function closedWidth() {
      wrap.style.width = 'max-content';
      var w = Math.ceil(open.scrollWidth) + 48;
      return Math.min(w, host.clientWidth || w);
    }
    function setClosed() {
      wrap.style.width = closedWidth() + 'px';
      wrap.style.height = CLOSED_HEIGHT + 'px';
    }
    function openCard() {
      var w = Math.min(host.clientWidth || MAX_WIDTH, MAX_WIDTH);
      card.style.width = w + 'px';
      wrap.style.width = w + 'px';
      wrap.style.height = card.offsetHeight + 'px';
      wrap.classList.add('sg-open');
      open.setAttribute('aria-expanded', 'true');
      card.setAttribute('aria-hidden', 'false');
      if ('inert' in card) card.inert = false;
      isOpen = true;
      setTimeout(function () { wa.focus({ preventScroll: true }); }, 250);
    }
    function closeCard() {
      wrap.classList.remove('sg-open');
      setClosed();
      open.setAttribute('aria-expanded', 'false');
      card.setAttribute('aria-hidden', 'true');
      if ('inert' in card) card.inert = true;
      isOpen = false;
      open.focus({ preventScroll: true });
    }

    open.addEventListener('click', openCard);
    close.addEventListener('click', closeCard);
    wrap.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) closeCard(); });

    setClosed();
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () { wrap.classList.add('sg-ready'); });
    });
    window.addEventListener('load', function () { if (!isOpen) setClosed(); });
    window.addEventListener('resize', function () {
      if (isOpen) {
        var w = Math.min(host.clientWidth || MAX_WIDTH, MAX_WIDTH);
        card.style.width = w + 'px';
        wrap.style.width = w + 'px';
        wrap.style.height = card.offsetHeight + 'px';
      } else setClosed();
    });
  }

  function init() {
    Array.prototype.forEach.call(
      document.querySelectorAll('.product__text a[href*="wa.me"]'),
      build
    );
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();